import { Dimensions, StyleSheet } from 'react-native';

import { LAYOUT } from '../reactor/common';
import C from './constants';

const { VIEWPORT: { H, W } } = LAYOUT;
const { PAGE_OFFSET } = C;
// const letterSpacing = -0.065;

const calc = ({
  height = H,
  width = W,
}) => {
  const PORTRAIT = height > width;
  const UNIT = width / 100;

  return StyleSheet.create({
    // -- Pages
    pageChapter: {
      flexDirection: PORTRAIT ? 'column' : 'row',
    },

    pageTitle: {
      paddingTop: PORTRAIT ? '40%' : '15%',
    },

    pageContent: {
      flexDirection: PORTRAIT ? 'column' : 'row',
    },

    pageContentText: {
      maxWidth: PORTRAIT ? '100%' : '37.5%',
    },

    // -- Elements
    box: {
      padding: PORTRAIT ? PAGE_OFFSET : UNIT * 2,
      width: PORTRAIT ? '100%' : '42.5%',
    },

    logo: {
      width: PORTRAIT ? 96 : 128,
      height: PORTRAIT ? 24 : 40,
    },

    media: {
      height: PORTRAIT ? height / 3.5 : height * 0.66,
      width: PORTRAIT ? width * 0.85 : width * 0.75,
    },

    cardStoryContainer: {
      width: PORTRAIT ? '92%' : undefined,
    },

    cardStorySponsored: {
      width: PORTRAIT ? '100%' : 482,
    },

    closeIcon: {
      width: PORTRAIT ? 36 : 40,
      height: PORTRAIT ? 36 : 40,
      opacity: 0.5,
    },
  });
};

class Layout {
  constructor({ height, width } = Dimensions.get('window')) {
    this.style = calc({ height, width });
  }

  get STYLE() {
    return this.style;
  }

  calc({ height, width } = Dimensions.get('window')) {
    this.style = calc({ height, width });
  }
}

export default new Layout();
